<template>
	<el-dialog title="详情" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page_warp scroll-view">

			<div class="custUpWarp" style="max-height: 500px; overflow: auto" v-show="index == 0">
				<div class="rpt_warp">
					<div class="flex">
						<div class="rpt_tit">基本信息</div>
						<!-- <div class="editimg fontSize18">
							<div v-if="vehedit" class="flex">
								<div class="mr-10" @click="veheditsave">保存</div>
								<div @click="veheditChange(false)">取消</div>
							</div>
							<div @click="veheditChange(true)" v-else>编辑</div>
						</div> -->
					</div>
					<div class="rpt_box2">
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>托运商:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="shipperName" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>贸易商:
								</div>

								<div class="input_box">
									<el-input type="text" v-model="supplierName" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>承运商:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="carrierName" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>

						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>车牌号:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorVehHeadNo" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>货品:
								</div>
								<div class="input_box">
									<el-select v-model="lorGoods" placeholder="请选择货品" disabled>
										<el-option label="LNG" :value="1" />
										<el-option label="CNG" :value="2" />
									</el-select>
								</div>
							</div>

							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>单/分卸:
								</div>
								<div class="input_box">
									<el-select v-model="lorLoadType" placeholder="" disabled>
										<el-option label="单装单卸" value="0" />
										<el-option label="单装分卸" value="1" />
									</el-select>
								</div>
							</div>
						</div>

					</div>
				</div>

				<div class="rpt_warp">
					<div class="flex">
						<div class="rpt_tit">装货信息</div>
						<!-- <div class="editimg fontSize18">
							<div v-if="vehedit" class="flex">
								<div class="mr-10" @click="veheditsave">保存</div>
								<div @click="veheditChange(false)">取消</div>
							</div>
							<div @click="veheditChange(true)" v-else>编辑</div>
						</div> -->
					</div>
					<div class="rpt_box2">
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>装货地:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorLoadName" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>计划装货时间:
								</div>

								<div class="input_box">
									<el-input type="text" v-model="lorLoadpTime" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>计划装货吨位:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorLoadpWeightSum" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

						</div>

						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>装货到站时间:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorLoadsTime" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>装货开始时间:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorLoadStartTime" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>实际装货吨位:
								</div>
								<div class="input_box">
									<el-input v-model="lorLoadsWeightSum" type="number" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

						</div>

						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>装货离站时间:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorLoadOffsiteTime" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>表显里程（装货）:
								</div>
								<div class="input_box">
									<el-input v-model="lorLoadOdometer" type="number" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>装货磅单编号:
								</div>
								<div class="input_box">
									<el-input v-model="lorLoadPound" type="number" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>装货磅单照片:
								</div>
								<div class="upRpic_icon_item2" v-viewer>
									<img class="upRpic2_icon" :src="lorLoadPouUrl" />
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>表显里程照片:
								</div>
								<div class="upRpic_icon_item2" v-viewer>
									<img class="upRpic2_icon" :src="lorLoadOdoUrl" />
								</div>
							</div>
							<div class="input_cell">

							</div>
						</div>


					</div>
				</div>

				<div class="rpt_warp m-top50">
					<div class="flex">
						<div class="rpt_tit">卸货信息</div>
						<!-- <div class="editimg fontSize18">
							<div v-if="vehedit" class="flex">
								<div class="mr-10" @click="veheditsave">保存</div>
								<div @click="veheditChange(false)">取消</div>
							</div>
							<div @click="veheditChange(true)" v-else>编辑</div>
						</div> -->
					</div>
					<div class="rpt_box2">
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>卸货地:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorlUnlName" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>计划卸货时间:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorlUnlpTime" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>计划卸货吨位:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorUnlpWeightSum" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>

						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>卸货到站时间:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorlUnlsTime" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>卸货开始时间:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorlUnlStartTime" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>实际卸货吨位:
								</div>
								<div class="input_box">
									<el-input v-model="lorUnlsWeightSum" type="number" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>

						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>卸货离站时间:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorlUnlOffsiteTime" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>途损吨位:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorLossWeightSum" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>表显里程（卸货）:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorlUnlOdometer" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>卸货磅单照片:
								</div>
								<div class="upRpic_icon_item2" v-viewer>
									<img class="upRpic2_icon" :src="lorlUnlPouUrl" />
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>表显里程照片:
								</div>
								<div class="upRpic_icon_item2" v-viewer>
									<img class="upRpic2_icon" :src="lorlUnlOdoUrl" />
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>签收单照片:
								</div>
								<div class="upRpic_icon_item2" v-viewer>
									<img class="upRpic2_icon" :src="lorlUnlDeliveryUrl" />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="rpt_warp m-top50">
					<div class="flex">
						<div class="rpt_tit">运输信息</div>
						<!-- <div class="editimg fontSize18">
							<div v-if="vehedit" class="flex">
								<div class="mr-10" @click="veheditsave">保存</div>
								<div @click="veheditChange(false)">取消</div>
							</div>
							<div @click="veheditChange(true)" v-else>编辑</div>
						</div> -->
					</div>
					<div class="rpt_box2">
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>装货时长:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorLoadDuration" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>卸货时长:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorUnlDuration" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>重车时长:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorHeaDuration" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>空车时长:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorEmpDuration" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>在途时长:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorTravelDuration" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>总时长:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorSumDuration" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>重车里程:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorHeaMilage" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>空车里程:
								</div>

								<div class="input_box">
									<el-input type="text" v-model="lorEmpMilage" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>总里程:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorSumMilage" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>

						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>挂车号:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorVehTailNo" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>驾驶员:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="odrMDirName" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>押运员:
								</div>
								<div class="input_box">
									<el-input type="text" v-model="odrYayunName" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="rpt_warp">
					<div class="flex">
						<div class="rpt_tit">收入信息</div>
						<!-- <div class="editimg fontSize18">
							<div v-if="vehedit" class="flex">
								<div class="mr-10" @click="veheditsave">保存</div>
								<div @click="veheditChange(false)">取消</div>
							</div>
							<div @click="veheditChange(true)" v-else>编辑</div>
						</div> -->
					</div>
					<div class="rpt_box2">
						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>运费里程(KM):
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorFreightMilage" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>运费吨位(吨):
								</div>

								<div class="input_box">
									<el-input type="text" v-model="lorFreightWeight" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>运费单价(元/吨/公里):
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorFreightPrice" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>

						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>运费收入(元):
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorFreightMoney" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>压车费收入(元):
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorOccupyIncome" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>

							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>分卸费收入(元):
								</div>
								<div class="input_box">
									<el-input v-model="lorUnloadIncome" type="number" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>

						<div class="input_row">
							<div class="input_cell">
								<div class="fontSize14 label col-333">
									<span class="col-ff0">*</span>总收入(元):
								</div>
								<div class="input_box">
									<el-input type="text" v-model="lorSumIncome" placeholder="请输入内容"
										:readonly="veheditisReadOnly"></el-input>
								</div>
							</div>
						</div>

					</div>
				</div>

			</div>

			<span class="dialog-footer">
				<span class="btn bg-default" v-on:click="closeModal()">关闭</span>
			</span>

		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		computed,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	export default defineComponent({
		name: "Detail",
		emits: ["getData"],

		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {});
			});

			const data = reactive({
				isDetail: false,
				index: 0,
				page: 1,
				pageSize: 1000,
				totalCount: 0,
				tableData: [],

				lorId: "",
				shipperName: "",
				lorLoadName: "",
				lorlUnlName: "",
				lorVehHeadNo: "",
				lorVehTailNo: "",
				odrMDirName: "",
				odrYayunName: "",
				lorGoods: "",
				lorLoadpTime: "",
				lorLoadsTime: "",
				lorLoadStartTime: "",
				lorLoadOffsiteTime: "",
				lorLoadpWeightSum: "",
				lorLoadsWeightSum: "",
				lorLoadOdometer: "",
				lorLoadPound: "",
				lorLoadOdoUrl: "",
				lorLoadPouUrl: "",
				lorlUnlpTime: "",
				lorlUnlsTime: "",
				lorlUnlStartTime: "",
				lorlUnlOffsiteTime: "",
				lorUnlpWeightSum: "",
				lorUnlsWeightSum: "",
				lorlUnlOdometer: "",
				lorlUnlPouUrl: "",
				lorlUnlOdoUrl: "",
				lorlUnlDeliveryUrl: "",
				lorLossWeightSum: "",
				lorLoadDuration: "",
				lorUnlDuration: "",
				lorHeaDuration: "",
				lorEmpDuration: "",
				lorTravelDuration: "",
				lorSumDuration: "",
				lorHeaMilage: "",
				lorEmpMilage: "",
				lorSumMilage: "",
				lorFreightMilage: "",
				lorFreightWeight: "",
				lorFreightPrice: "",
				lorFreightMoney: "",
				lorOccupyIncome: "",
				lorUnloadIncome: "",
				lorSumIncome: "",
				lorLoadType: "",
			});

			//重置数据
			const init = async (id) => {
				data.lorId = id;
				data.isDetail = true;
				console.log(id);
				// getDetail(id);

				let params = {
					lorId: data.lorId,
				};
				const r = await proxy.$http.get(apiObj.ordDetail, params);
				if (r.respCode == 0 || r.respCode == "0000") {
					data.shipperName = r.orderInfo.shipperName;
					data.lorLoadName = r.orderInfo.lorLoadName;
					data.lorlUnlName = r.orderInfo.lorUnlName;
					data.lorVehHeadNo = r.orderInfo.lorVehHeadNo;
					data.lorVehTailNo = r.orderInfo.lorVehTailNo;
					data.odrMDirName = r.orderInfo.odrMDirName;
					data.odrYayunName = r.orderInfo.odrYayunName;
					data.lorGoods = r.orderInfo.lorGoods;
					data.lorLoadpTime = r.orderInfo.lorLoadpTime;
					data.lorLoadsTime = r.orderInfo.lorLoadsTime;
					data.lorLoadStartTime = r.orderInfo.lorLoadStartTime;
					data.lorLoadOffsiteTime = r.orderInfo.lorLoadOffsiteTime;
					data.lorLoadpWeightSum = r.orderInfo.lorLoadpWeightSum;
					data.lorLoadsWeightSum = r.orderInfo.lorLoadsWeightSum;
					data.lorLoadOdometer = r.orderInfo.lorLoadOdometer;
					data.lorLoadPound = r.orderInfo.lorLoadPound;
					data.lorLoadOdoUrl = r.orderInfo.lorLoadOdoUrl;
					data.lorLoadPouUrl = r.orderInfo.lorLoadPouUrl;
					data.lorlUnlpTime = r.orderInfo.unloadList[0].lorlUnlpTime;
					data.lorlUnlsTime = r.orderInfo.unloadList[0].lorlUnlsTime;
					data.lorlUnlStartTime = r.orderInfo.unloadList[0].lorlUnlStartTime;
					data.lorlUnlOffsiteTime = r.orderInfo.unloadList[0].lorlUnlOffsiteTime;
					data.lorlUnlOdometer = r.orderInfo.unloadList[0].lorlUnlOdometer;
					data.lorlUnlPouUrl = r.orderInfo.unloadList[0].lorlUnlPouUrl;
					data.lorlUnlOdoUrl = r.orderInfo.unloadList[0].lorlUnlOdoUrl;
					data.lorlUnlDeliveryUrl = r.orderInfo.unloadList[0].lorlUnlDeliveryUrl;
					data.lorUnlpWeightSum = r.orderInfo.lorUnlpWeightSum;
					data.lorUnlsWeightSum = r.orderInfo.lorUnlsWeightSum;
					data.lorLossWeightSum = r.orderInfo.lorLossWeightSum;
					data.lorLoadDuration = timeDeltaCount(r.orderInfo.lorLoadDuration);
					data.lorUnlDuration = timeDeltaCount(r.orderInfo.lorUnlDuration);
					data.lorHeaDuration = timeDeltaCount(r.orderInfo.lorHeaDuration);
					data.lorEmpDuration = timeDeltaCount(r.orderInfo.lorEmpDuration);
					data.lorTravelDuration = timeDeltaCount(r.orderInfo.lorTravelDuration);
					data.lorSumDuration = timeDeltaCount(r.orderInfo.lorSumDuration);
					data.lorHeaMilage = r.orderInfo.lorHeaMilage;
					data.lorEmpMilage = r.orderInfo.lorEmpMilage;
					data.lorSumMilage = r.orderInfo.lorSumMilage;
					data.lorFreightMilage = r.orderInfo.lorFreightMilage;
					data.lorFreightWeight = r.orderInfo.lorFreightWeight;
					data.lorFreightPrice = r.orderInfo.lorFreightPrice;
					data.lorFreightMoney = r.orderInfo.lorFreightMoney;
					data.lorOccupyIncome = r.orderInfo.lorOccupyIncome;
					data.lorUnloadIncome = r.orderInfo.lorUnloadIncome;
					data.lorSumIncome = r.orderInfo.lorSumIncome;
					data.lorLoadType = r.orderInfo.lorLoadType;
				}
			};


			const navClick = (index) => {
				data.index = index;
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};

			const timeDeltaCount = function(time) {
				if (time) {
					var s = time % 60;
					var m = Math.floor(time / 60) % 60;
					var h = Math.floor(Math.floor(time / 60) / 60);

					if (h !== 0) {
						return h + "小时" + m + "分";
					}
					if (m !== 0) {
						return m + "分";
					}
					return s + "秒";
				} else {
					return ''
				}
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				dialogClosedHandle,
				getData,
				navClick,
				timeDeltaCount,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 600px;
	}

	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	.nav_item span {
		font-size: 18px;
		color: #666666;
		line-height: 78px;
	}

	.nav_item_ac span {
		color: #26ca67 !important;
	}

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #2eb779;
		bottom: 5px;
	}


	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.m-top10 {
		margin-top: 10px;
	}

	.m-top50 {
		margin-top: 50px;
	}

	.rpt_warp {
		width: 100%;
		background: #fff;
	}

	.rpt_tit {
		width: 100%;
		height: 70px;
		border-bottom: 1px solid #eeeeee;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 42px;
	}

	.rpt_box1 {
		width: 100%;
		height: 240px;
	}

	.pic-box {
		display: flex;

		margin-left: 42px;
	}

	.pic {
		width: 154px;
		height: 154px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.pic .upload-icon {
		width: 54px;
		height: 54px;
	}

	.pic .userHeadImg {
		width: 154px;
		height: 154px;
	}

	.identity-card {
		display: flex;
		margin-left: 50px;
	}

	.identity {
		width: 227px;
		height: 150px;
		margin-left: 10px;
		margin-right: 40px;
	}

	.identity img {
		width: 227px;
		height: 150px;
	}

	.rpt_box2 {
		width: 100%;
		padding-top: 30px;
		padding-bottom: 30px;
	}

	.input_row {
		width: 95%;
		margin-left: 1%;
		height: 38px;
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
	}

	.input_row2 {
		width: 95%;
		margin-left: 1%;
		height: 88px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-between;
	}

	.input_cell {
		width: 33%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.input_cell2 {
		width: 33%;
		height: 150px;
		display: flex;
		align-items: center;
	}

	.input_cell .label {
		width: 148px;
		text-align: right;
	}

	.input_box {
		flex: 1;
		height: 100%;
		margin-left: 30px;
		display: flex;
		align-items: center;
	}

	.rpt_box3 {
		width: 100%;
		height: 286px;
		justify-content: space-between;
	}

	.rpic_img_warp {
		margin-left: 62px;
	}

	.rpic_img_box {
		width: 479px;
		height: 200px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		flex-wrap: wrap;
	}

	.rpic_img_box2 {
		width: 200px;
		height: 200px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		align-items: flex-start;
	}

	.upRpic_icon_item {
		margin-top: 20px;
		width: 125px;
		height: 60px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic_icon_item2 {
		margin-top: 110px;
		width: 125px;
		height: 125px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic2_icon {
		width: 125px;
		height: 125px;
		/* width: 100%;
			hieght: auto; */
	}

	.upRpic_icon {
		width: 20px;
		height: 20px;
	}

	.image-box-item-del {
		position: absolute;
		right: 0;
		top: 0;
		width: 20px;
		height: 20px;
		cursor: pointer;
	}

	.image-box-item-del img {
		width: 20px;
		height: 20px;
	}

	.rpic_img_text {
		width: 100px;
		height: 200px;
		display: flex;
		flex-direction: column;
		align-content: center;
		justify-content: center;
	}

	.cretUrl_img_warp {
		height: 181px;
	}

	.cretUrl_img_box {
		width: 360px;
		height: 180px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 30px;
	}

	.rpt_box4 {
		width: 98%;
		margin-left: 1%;
		padding: 30px 0;
		border-bottom: 1px solid #eeeeee;
	}

	.rpt_bank_info {
		width: 50%;
	}

	.rpt_bank_row {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.rpt_bank_lable {
		width: 148px;
		text-align: right;
	}

	.bank_input_box {
		width: 500px;
		margin-left: 20px;
	}

	.rpt_bank_img_warp {
		width: 50%;
		display: flex;
		margin-right: 30px;
	}

	.bank_card_img_warp {
		width: 478px;
		height: 176px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.conName_input {
		border: none;
		outline: none;
		flex: 1;
		padding-left: 10px;
	}

	.fuzi {
		width: 35px;
		height: 16px;
		background: #20ca68;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 12px;
		color: #fff;
		padding: 0 5px;
	}

	.serach_btn {
		width: 87px;
		height: 38px;
		background: #2EB779;
		border-radius: 6px;
		text-align: center;
		line-height: 38px;
		color: #fff;
		cursor: pointer;
		margin-left: 20px;
	}

	.menu_warp {
		width: 100%;
		height: 100%;
		background: #f5f5f4;
		overflow: auto;
	}

	.tit_warp {
		width: 100%;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
		height: 42px;
		line-height: 42px;
		font-size: 14px;
		color: #333;
		overflow: hidden;
		background-color: #fff;
		border-radius: 2px 2px 0 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.header_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
	}

	.editimg {
		width: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}
</style>